// extracted by mini-css-extract-plugin
export default {"base":"PreviewEdit_base__gjhOa"};